import React from 'react';
import { Link } from 'react-router-dom';
import About1 from '../../images/painting2.jpg';
import { Helmet } from 'react-helmet';

const Paintingwork = (props) => {

      const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    
    return (

         <>
      <Helmet>
        <title>Painting Works</title>
        <meta name="description" content="From Color Consultation to Perfect Finish" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="row align-items-center">

                <div className="col-lg-6 col-12">
                        <div className="about-left">
                            <img src={About1} alt="" />
                            
                        </div>
                    </div>

                    <div className="col-lg-6 col-12">
                        <div className="about-right">
                            <div className="text">
                                <span>About</span>
                                <h1>Painting Works</h1>
                                <h6>From Color Consultation to Perfect Finish</h6>
                                <p>
                               A fresh coat of paint can completely transform your space. At YATRI INTERIORS,
                                we deliver high-quality interior and exterior painting services in Bengaluru.
                                </p>
                                <h4>Our painting services cover :</h4>
                                <ul>
                                    <li>Interior emulsion painting</li>
                                    <li>Textured and designer walls</li>
                                    <li>Waterproofing solutions</li>
                                    <li>Wood and metal painting</li>
                                    <li>Post-painting cleanup</li>
                                    <p>Choose your colors — we’ll bring them to life!</p>
                                </ul>
                              <a href='tel:9663222146' className='theme-btn'>Call Us: +91 96632 22146</a>
                            </div>
                        </div>
                    </div>
                    
                
                </div>
            </div>
        </section>
    </>
        
    )
}

export default Paintingwork ;